import { useMotion } from "@vueuse/motion";
import { useAnimation } from "./useAnimation";

export function useToUp(refElement, delay = 0) {
  const { createSpring } = useAnimation();

  const setupMotion = () => {
    const motionInstance = useMotion(refElement, {
      initial: {
        y: 100,
        opacity: 0,
      },
      enter: {
        y: 0,
        opacity: 1,
        transition: createSpring(300, 20, delay),
      },
    });
    return motionInstance;
  };

  return { setupMotion };
}
